import { render } from "./studentSpecialTaskList.vue?vue&type=template&id=dfb13508&scoped=true"
import script from "./studentSpecialTaskList.vue?vue&type=script&lang=js"
export * from "./studentSpecialTaskList.vue?vue&type=script&lang=js"

import "./studentSpecialTaskList.vue?vue&type=style&index=0&id=dfb13508&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb13508"]])

export default __exports__